import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";

export const MCQComprehensionKeyboard = ({
  question,
  onSubmit,
  enableSkip,
  isDisabled,
}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [hoverIndex, setHoverIndex] = useState(null);

  useEffect(() => {
    setSelectedOption("");
  }, [question]);

  const handleOptionChange = (option) => {
    if (isDisabled) return;
    setSelectedOption(option);
  };

  const submit = (skipped = false) => {
    if (isDisabled) return;
    onSubmit(selectedOption, skipped);
    setSelectedOption("");
  };

  // inline styles
  const containerStyle = { marginBottom: "1rem" };
  const listStyle = {
    listStyle: "none",
    margin: "0 6px",
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  };

  const liStyle = {
        position: "relative",
        margin: "0 5px 0 0",
        width: "100%",
        display: "flex",
   alignItems: "center", 
        boxShadow: "0 0 3px -1px rgba(0,0,0,0.3)",
        border: "1px solid #b5b5b5",
        borderRadius: "5px",
        cursor: "pointer",
        display: "flex",
        alignItems: "flex-start",
        padding: "8px",
        background: "transparent",
      };
    
  const inputStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
    opacity: 0,
    cursor: "pointer",
    border: "none"
  };
  
  const labelStyle = {
    cursor: "pointer",
    flexGrow: 1,
    wordBreak: "break-word",  // wrap long text
    lineHeight: 1.4,
  };

  return (
    <div style={containerStyle}>
      <ul style={listStyle}>
        {question?.options?.map((option, index) => {
          const isSelected = selectedOption === option;
          const isHovered = hoverIndex === index;

          return (
            <li
              key={`${option}_${index}_${question.question}`}
              style={{
                ...liStyle,
                background: isSelected
                  ? "rgba(204,249,0,0.5)"
                  : isHovered
                    ? "#DDD"
                    : "transparent",
              }}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              <input
                type="radio"
                id={`opt_${index}`}
                name={question.question}
                onChange={() => handleOptionChange(option)}
                checked={isSelected}
                disabled={isDisabled}
                style={inputStyle}
              />
              <label htmlFor={`opt_${index}`} style={labelStyle}>
                {option}
              </label>
            </li>
          );
        })}
      </ul>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "12px",
          position: "relative",
        }}
      >
        <Button
          onClick={() => submit()}
          disabled={!selectedOption}
          sx={{
            width: "200px",
            height: "100%",
            backgroundColor: "#ccf900",
            color: "#666666",
            fontWeight: 600,
            textDecoration: "none",
            "&:hover": { backgroundColor: "rgba(204,249,0,0.8)" },
          }}
        >
          Submit
        </Button>

        {enableSkip && (
          <span
            onClick={() => submit(true)}
            style={{
              position: "absolute",
              right: "20px",
              fontSize: "14px",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Skip &gt;&gt;
          </span>
        )}
      </div>
    </div>
  );
};
